import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import RectangularBigBtn from '../../../../components2/Buttons/RectangularbigBtn';
import { BankCommentTitle, Commentsuggestion } from '../popupStyle';
import editIcon from '../../../../static/icons/edit_icon_purple_24.svg';
import closecircle from '../../../../static/img/closecircle.svg';

const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  border-bottom: 1px solid #c9c6cc80;
`;
const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #7200E0;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #7200E0;
  &:hover { background: #f2f1f380; }
`;
const CloseButton = styled.button`
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { opacity: 0.8; }
`;

export default function SuccessCriteriaDialog({
  successCriteria,
  setSuccessCriteriaPreviewDialog,
  showActionButton = false,
  onActionButtonClick = () => {},
  isSystem = false,
  showEditButton = true,
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const history = useHistory();

  const closeDialog = () => {
    setIsDialogOpen(false);
    setSuccessCriteriaPreviewDialog(false);
  };

  const handleEdit = () => {
    if (successCriteria?.id && !showActionButton) {
      closeDialog();
      history.push(`/tools/successcriterias/${successCriteria.id}`);
    }
  };

  const importSuccessCriteria = () => {
    onActionButtonClick();
    setSuccessCriteriaPreviewDialog(false);
  };

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        maxWidth="md"
        PaperProps={{ style: { width: 750 } }}
        sx={{ zIndex: 2147483647 }}
      >
        <PreviewHeader>
          <HeaderActions>
            {showEditButton && successCriteria?.id && !showActionButton && !isSystem && (
              <EditButton onClick={handleEdit} type="button">
                <img src={editIcon} alt="Edit" width={16} height={16} />
                <span>Edit</span>
              </EditButton>
            )}
            <CloseButton onClick={closeDialog} type="button" aria-label="Close">
              <img src={closecircle} alt="Close" width={20} height={20} />
            </CloseButton>
          </HeaderActions>
        </PreviewHeader>
        <DialogContent>
          {successCriteria?.title && (
            <TitleContainer>
              <TitleText>{successCriteria.title}</TitleText>
            </TitleContainer>
          )}
          <SuggestionsContainer>
            {successCriteria?.criterias && successCriteria.criterias.length > 0 ? (
              successCriteria.criterias.map((criteria, idx) => {
                const isLastCriteria = idx === successCriteria.criterias.length - 1;
                const objectives = criteria?.objectives && criteria.objectives.length > 0 
                  ? criteria.objectives 
                  : [{ description: 'No objectives' }];
                const lastObjectiveIdx = objectives.length - 1;
                
                return (
                  <div key={idx}>
                    {objectives.map((objective, objectiveIdx) => {
                      const isLastObjective = isLastCriteria && objectiveIdx === lastObjectiveIdx;
                      return (
                        <Commentsuggestion 
                          key={objectiveIdx}
                          style={isLastObjective ? { borderBottom: 'none' } : {}}
                        >
                          {objective.description}
                        </Commentsuggestion>
                      );
                    })}
                  </div>
                );
              })
            ) : (
              <Commentsuggestion style={{ borderBottom: 'none' }}>No criteria available</Commentsuggestion>
            )}
          </SuggestionsContainer>
          {showActionButton && (
            <ActionButtonContainer>
              <RectangularBigBtn text="Import" onClickFn={importSuccessCriteria} />
            </ActionButtonContainer>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

const ActionButtonContainer = styled.div`
  margin-top: 10px;
`;

const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TitleContainer = styled.div`
  margin-bottom: 16px;
`;

const TitleText = styled.h3`
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-weight: 600;
  color: #1e252a;
  margin: 0;
`;
